import { Row } from "react-styled-flexboxgrid";
import { Color } from "../../theme/Color";
import StyledModal from "../Modal";
import Spacer from "../Spacer";

const EarlyBirdOfferModal = (props) => {
  return (
    <StyledModal
      modalIsOpen={props.showConsentModal}
      setIsOpen={props.setShowConsentModal}
      title={`Early Bird Offer`}
    >
      <Row center="xs" style={{ color: Color.Grey3 }}>
        <Spacer all={2}>
          <p>
            We are offering all new businesses a <b>3-month Free Trial</b> when
            they sign-up. This trial period allows businesses to experience
            Valmeegos features and benefits firsthand without any upfront costs.
          </p>{" "}
          <p>
            Following the Free Trial period businesses continue their membership
            with a 12-month Early Bird monthly subscription of €25 (plus vat if
            applicable).
          </p>
          <p>Cancel at any time.</p>
        </Spacer>
      </Row>
    </StyledModal>
  );
};

export default EarlyBirdOfferModal;
